import styled from "styled-components";

// TEXT

// STYLES
export const Container = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;

  svg:nth-of-type(1) {
    flex: 1;
  }
  svg:nth-of-type(2) {
    flex: 1.75;
  }
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
